import {cloneDeep, get} from 'lodash';
import {getNumber, getString} from 'Core/helpers/data';
import {ManageVideosItemDataObject} from '../dataObjects';
import * as languageDataMap from 'Language/dataMap';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ManageVideosItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ManageVideosItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'title'),
		getString(result, 'description'),
		getString(result, 'linkEmbeded'),
		languageDataMap.input(get(result, 'languageData')),
		getNumber(result, 'displayOrdinal'),
	);

	return result;
}

// @note: There is no output function since list is read-only.